"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusableSelector = void 0;
/** A selector that will match elements that can be focused. */
exports.focusableSelector = 'a:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'area:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'button:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'input:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'object:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'select:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'textarea:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    '[tabindex]:not([tabindex^="-"]):not([tabindex=""])';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/Constants.js
// module id = 1647
// module chunks = 8